import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

interface EmbeddedErrorProps {
  applicationName: string;
  onRetry: () => void;
  onReload: () => void;
  onOpenInNewTab: () => void;
}

export function EmbeddedError({
  applicationName,
  onRetry,
  onReload,
  onOpenInNewTab,
}: EmbeddedErrorProps) {
  const { t } = useTranslation('entity-portal');

  return (
    <Box
      role="alert"
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        bgcolor: (theme) => alpha(theme.palette.background.default, 0.94),
      }}
    >
      <Alert severity="error" sx={{ maxWidth: 520, width: '100%' }}>
        <Stack spacing={1.5}>
          <Typography variant="subtitle1">
            {t('embedded.embeddedErrorTitle', { application: applicationName })}
          </Typography>
          <Typography variant="body2">{t('embedded.embeddedErrorMessage')}</Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
            <Button
              variant="contained"
              size="small"
              startIcon={<RefreshOutlinedIcon />}
              onClick={onRetry}
            >
              {t('common.retry')}
            </Button>
            <Button
              variant="outlined"
              size="small"
              startIcon={<RefreshOutlinedIcon />}
              onClick={onReload}
            >
              {t('embedded.embeddedReloadApplication')}
            </Button>
            <Button
              variant="outlined"
              size="small"
              startIcon={<OpenInNewOutlinedIcon />}
              onClick={onOpenInNewTab}
            >
              {t('embedded.embeddedOpenInNewTab')}
            </Button>
          </Stack>
        </Stack>
      </Alert>
    </Box>
  );
}
